export default __webpack_public_path__ + "images/4c2c2c8279571ac3166d6618afc00de2-Industry-Light.woff2";